module.exports = __webpack_public_path__ + "static/media/start_ziel_03_.d9dfa6ec.jpg";